import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c97e3d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "message-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "그렇다면 앱스토어에 칭찬을 남겨주세요", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, [
  /*#__PURE__*/_createTextVNode(" 불편한 점이나 건의사항을"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 저희에게 알려주세요! ")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "예약이 되지 않았습니다.", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["MainNavigationBar"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["UserBlockingMessage"], {
            shouldShow: $setup.isBookBlocked || $setup.isBoardBlocked,
            displayHTMLText: $setup.blockReleaseDtmHtmlStr
          }, null, 8 /* PROPS */, ["shouldShow", "displayHTMLText"]),
          ($setup.userInfo)
            ? (_openBlock(), _createBlock($setup["WelcomeMessages"], {
                key: 0,
                class: _normalizeClass({ gap: !$setup.isBoardBlocked && !$setup.isBoardBlocked }),
                userInfo: $setup.userInfo
              }, null, 8 /* PROPS */, ["class", "userInfo"]))
            : _createCommentVNode("v-if", true),
          ($setup.serviceInfo?.campaigns?.length)
            ? (_openBlock(), _createBlock($setup["CampaignBannerSwiper"], {
                key: 1,
                campaigns: $setup.serviceInfo.campaigns
              }, null, 8 /* PROPS */, ["campaigns"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" 카드 UI "),
        ($setup.shouldShowFavoriteLinesCardView)
          ? (_openBlock(), _createBlock($setup["FavoriteCardsView"], {
              key: 0,
              cardUpdateKey: $setup.cardUpdateKey,
              allCardsUpdateKey: $setup.allCardsUpdateKey,
              favoriteLines: $setup.favoriteLines,
              currentFavoriteLine: $setup.currentFavoriteLine,
              onBoardLine: $setup.onBoardLine,
              isBusRunning: $setup.isBusRunning,
              onGetBusLocation: $setup.getBusLocation,
              onGoToLineInfoDetail: $setup.goToLineInfoDetail,
              onSetIntervalBusLocation: $setup.setIntervalBusLocation,
              onOnClickBusStopLocation: $setup.showBusStopLocation,
              onOnChangedCheck: $setup.onChangedCheck,
              onShowTimeTable: $setup.showTimeTable,
              onUpdateBusLocation: $setup.updateBusLocation,
              onUpdateCurrentFavoriteLine: $setup.updateCurrentFavoriteLine
            }, null, 8 /* PROPS */, ["cardUpdateKey", "allCardsUpdateKey", "favoriteLines", "currentFavoriteLine", "onBoardLine", "isBusRunning"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" 목록 UI "),
              _createVNode($setup["FavoriteListView"], {
                favoriteLines: $setup.favoriteLines,
                fullSeatLineRouteCount: $setup.fullSeatLineRouteCount,
                onOnClickBoardingStatusButton: $setup.handleClickBoardingStatusButton,
                onOnSuccessRemoveFavoriteLine: $setup.getFavoriteLines,
                onUpdateCurrentFavoriteLine: $setup.updateCurrentFavoriteLine
              }, null, 8 /* PROPS */, ["favoriteLines", "fullSeatLineRouteCount"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
        _createVNode($setup["UtilityButton"])
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.onBoardLine && $setup.shouldShowBoardingLineInfoModal,
        onBackHandler: () => $setup.toggleShowBoardingLineInfoModal(false)
      }, {
        default: _withCtx(() => [
          ($setup.onBoardLine)
            ? (_openBlock(), _createBlock($setup["BoardingLineInfoModal"], {
                key: 0,
                onBoardFavoriteLine: $setup.currentFavoriteLine,
                onBoardLine: $setup.onBoardLine,
                busLocations: $setup.busLocations,
                onUpdateFavoriteLine: $setup.updateFavoriteLine,
                onOnClickBusStopLocation: $setup.showBusStopLocation,
                onOnClickCloseBtn: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowBoardingLineInfoModal(false))),
                onOnClickRefreshButton: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateBusLocation(true)))
              }, null, 8 /* PROPS */, ["onBoardFavoriteLine", "onBoardLine", "busLocations"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowMap,
        onBackHandler: () => $setup.toggleShowMap(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["MapOfBusStop"], {
            targetBusStop: $setup.targetBusStop,
            onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowMap(false)))
          }, null, 8 /* PROPS */, ["targetBusStop"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowOpinion,
        onBackHandler: () => $setup.toggleShowOpinionPage(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["Opinion"], {
            onOnClickClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowOpinionPage(false)))
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowServiceEvaluation,
        onBackHandler: () => $setup.toggleShowServiceEvaluation(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["ServiceEvaluation"], {
            onOnClickClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.toggleShowServiceEvaluation(false)))
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowTimeTable && !!$setup.targetBusStopForTimeTable,
        onBackHandler: () => $setup.toggleShowTimeTable(false)
      }, {
        default: _withCtx(() => [
          ($setup.targetBusStopForTimeTable)
            ? (_openBlock(), _createBlock($setup["TimeTableModal"], {
                key: 0,
                turnId: $setup.currentFavoriteLine?.turnId ?? '',
                busStop: $setup.targetBusStopForTimeTable,
                onOnClickCloseBtn: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleShowTimeTable(false)))
              }, null, 8 /* PROPS */, ["turnId", "busStop"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      ($setup.shouldShowBusStopLayoutModal)
        ? (_openBlock(), _createBlock($setup["BusStopLayoutModal"], {
            key: 0,
            turnUid: $setup.currentFavoriteLine?.turnId ?? '',
            busStopUid: $setup.targetBusStop?.id ?? '',
            busStopName: $setup.targetBusStop?.name ?? '',
            onOnClickCloseBtn: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleShowBusStopLayoutModal(false)))
          }, null, 8 /* PROPS */, ["turnUid", "busStopUid", "busStopName"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowSurveyNotice && $props.isColsedNoticeModal)
        ? (_openBlock(), _createBlock($setup["SurveyNoticeModal"], {
            key: 1,
            onOnClose: $setup.onCloseSurveyNotice,
            onOnClickSurveyNow: _cache[7] || (_cache[7] = ($event: any) => ($setup.toggleShowServiceEvaluation(true)))
          }))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowBusImage)
        ? (_openBlock(), _createBlock($setup["BusInfoModal"], {
            key: 2,
            buses: $setup.currentFavoriteLine?.buses ?? [],
            onOnClickClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.toggleShowBusImage(false)))
          }, null, 8 /* PROPS */, ["buses"]))
        : _createCommentVNode("v-if", true),
      ($setup.showReviewModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 3,
            title: "감사합니다!",
            okButtonTitle: "리뷰남기기",
            cancelButtonTitle: "다음에요",
            onOnClickCancelButton: _cache[9] || (_cache[9] = ($event: any) => ($setup.showReviewModal = false)),
            onOnClickOkButton: $setup.goToAppStore
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.showOpinionModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 4,
            title: "죄송합니다",
            okButtonTitle: "의견 남기기",
            cancelButtonTitle: "다음에요",
            onOnClickCancelButton: _cache[10] || (_cache[10] = ($event: any) => ($setup.showOpinionModal = false)),
            onOnClickOkButton: _cache[11] || (_cache[11] = ($event: any) => ($setup.toggleShowOpinionPage(true)))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowAlertForPushDisabled)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 5,
            title: "승하차 알림 설정",
            okButtonTitle: "종료하기",
            cancelButtonTitle: "취소",
            onOnClickOkButton: $setup.disablePushMessage,
            onOnClickCancelButton: _cache[12] || (_cache[12] = ($event: any) => ($setup.shouldShowAlertForPushDisabled = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, _toDisplayString($setup.stopClassStr) + " 알림을 종료하시겠습니까?", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowAlertForPushIsNotAllowed)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 6,
            title: $setup.getTitleOfPushOnAlert(),
            okButtonTitle: "확인",
            onOnClickOkButton: _cache[13] || (_cache[13] = ($event: any) => ($setup.shouldShowAlertForPushIsNotAllowed = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(" 승하차 및 공지사항 알림을 받으시려면 기기의 알림을 켜주세요 "),
                _hoisted_7,
                _createTextVNode(_toDisplayString($setup.pushSettingGuide), 1 /* TEXT */)
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowAlertForBookFail)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 7,
            title: "예약 실패",
            okButtonTitle: "확인",
            onOnClickOkButton: _cache[14] || (_cache[14] = ($event: any) => ($setup.shouldShowAlertForBookFail = false))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowReportModal)
        ? (_openBlock(), _createBlock($setup["ReportModal"], {
            key: 8,
            boardUid: $setup.currentFavoriteLine?.boardUid ?? '',
            lineName: $setup.lineName,
            lineStartTime: $setup.currentFavoriteLine?.lineStartTime ?? '-',
            busPlateNumber: $setup.currentFavoriteLine?.boardedCarNo ?? '-',
            onOnClickCloseBtn: _cache[15] || (_cache[15] = ($event: any) => ($setup.toggleShowReportModal(false)))
          }, null, 8 /* PROPS */, ["boardUid", "lineName", "lineStartTime", "busPlateNumber"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}